import { render, staticRenderFns } from "./Action_mail.vue?vue&type=template&id=e4b3f1c4&"
import script from "./Action_mail.vue?vue&type=script&lang=js&"
export * from "./Action_mail.vue?vue&type=script&lang=js&"
import style0 from "./Action_mail.vue?vue&type=style&index=0&id=e4b3f1c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports